import React from 'react';
import { Drawer, Box, IconButton, Typography } from '@mui/material';
import { BiX } from 'react-icons/bi';

interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  width?: number;
  keepMounted?: boolean;
}

const SidePanel = ({ open, onClose, title, children, width = 640, keepMounted = false }: SidePanelProps) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted,
      }}
      sx={{
        '& .MuiDrawer-paper': {
          width,
          boxSizing: 'border-box',
        },
      }}
    >
      {/* Header */}
      {title && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 3,
            pb: 2,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose} size="small">
            <BiX size={24} />
          </IconButton>
        </Box>
      )}

      {/* Content */}
      <Box sx={{ flex: 1, overflowY: 'auto', p: title ? 3 : 0, backgroundColor: 'background.default' }}>
        {children}
      </Box>
    </Drawer>
  );
};

export default SidePanel;
